// Минимально необходимое количество определенных заболеваний для завершения
export const DETECTED_DISEASE_MIN_COUNT = 3

export const EXPECTED_SYMPTOMS_COUNT = 2

// Порог совпадения симптомов для определения заболевания
export const DETECTED_DISEASE_MATCH_THRESHOLD = 0.8

export const MAX_DISEASES = 5

export const MAX_SYMPTOMS = 10

export const RTL_LANGUAGES = ["ar", "ur", "he", "fa"]
